import React from 'react';
import { Mail, Phone, MapPin, Globe } from 'lucide-react';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';
import Section from '../components/common/Section';
import SectionHeader from '../components/common/SectionHeader';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <MarketingNav transparent={false} />

      <main>
        <Section background="light" padding="xl">
          <div className="max-w-3xl">
            <Badge variant="primary" className="mb-4">Contact</Badge>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6">We’re here to help.</h1>
            <p className="text-lg md:text-xl text-text-muted">
              Reach out to the MHDF Momentum team for support, questions, or partnership requests.
            </p>
          </div>
        </Section>

        <Section background="white" padding="lg">
          <SectionHeader
            badge="Contact Details"
            title="Get in touch"
            subtitle="We respond within 1-2 business days."
            alignment="left"
          />
          <div className="mt-10 grid gap-6 md:grid-cols-2">
            <Card variant="feature" hover>
              <div className="flex items-center gap-3 mb-3">
                <Mail className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">Email</h3>
              </div>
              <p className="text-text-muted">support@mhdfmomentum.com</p>
            </Card>
            <Card variant="feature" hover>
              <div className="flex items-center gap-3 mb-3">
                <Phone className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">Phone</h3>
              </div>
              <p className="text-text-muted">(409) 550-1846</p>
            </Card>
            <Card variant="feature" hover>
              <div className="flex items-center gap-3 mb-3">
                <Globe className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">Website</h3>
              </div>
              <p className="text-text-muted">www.mhdfmomentum.com</p>
            </Card>
            <Card variant="feature" hover>
              <div className="flex items-center gap-3 mb-3">
                <MapPin className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">Address</h3>
              </div>
              <p className="text-text-muted">6120 College St., Suite D185<br />Beaumont, TX 77707</p>
            </Card>
          </div>
        </Section>
      </main>

      <MarketingFooter />
    </div>
  );
};

export default ContactPage;
